import { render, staticRenderFns } from "./managerNeedVerify.vue?vue&type=template&id=4fb28910&scoped=true"
import script from "./managerNeedVerify.vue?vue&type=script&lang=js"
export * from "./managerNeedVerify.vue?vue&type=script&lang=js"
import style0 from "./managerNeedVerify.vue?vue&type=style&index=0&id=4fb28910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb28910",
  null
  
)

export default component.exports